// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6d21ff5d035cbddd1761","655":"5753b80e87f119e64150"}[chunkId] + ".js";
};